<!--
 * @Author: your name
 * @Date: 2020-10-19 08:57:03
 * @LastEditTime: 2020-11-05 19:09:50
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \wzl\src\App.vue
-->
<template>
  <div id="app">
    <navigator />
    <router-view />
    <foot />
  </div>
</template>

<script>
import navigator from '@/components/navigator'
import foot from '@/components/footer'
export default {
  components: {
    navigator,
    foot,
  },
}
</script>

<style lang="less">
html,
body {
  margin: 0;
  position: static;
  min-width: 1200px;
}

ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

p,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
}

.wrapper {
  margin: 0 auto;
  width: 1200px;
}
.banner {
  width: 100%;
  height: 660px;
  object-fit: cover;
}
.pub-title {
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 40px;
  color: #1a1a1a;
  text-align: center;
  margin-bottom: 6px;
}

.pub-sub-title {
  font-size: 22px;
  font-family: Arial;
  font-weight: 400;
  line-height: 26px;
  color: #909090;
  padding-bottom: 10px;

  text-align: center;
  position: relative;
}
.pub-sub-title::after {
  content: '';
  left: 50%;
  bottom: 0;
  width: 120px;
  border-bottom: 4px solid #006C8F;
  position: absolute;
  transform: translateX(-50%);
}
.mask {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.rich {
  img {
    max-width: 100%;
  }
}
.el-icon-circle-close {
  color: #ffffff;
  font-size: 80px;
}
@media (min-width: 767px) {
  .mobile {
    display: none !important;
  }
}
@media (max-width: 767px) {
  html,
  body {
    margin: 0;
    position: static;
    min-width: unset;
  }
  .pc {
    display: none !important;
  }
  #app {
    position: static;
    width: 100vw;
  }
  .wrapper {
    width: 100%;
  }
  .pub-title {
    font-size: 0.4rem;
    margin-bottom: 0.12rem;
    line-height: 0.4rem;
  }
  .pub-sub-title {
    font-size: 0.28rem;
    padding-bottom: 6px;
    line-height: 0.32rem;
    text-transform: uppercase;
  }
  .pub-sub-title::after {
    width: 1.2rem;
  }
  .rich {
    overflow: hidden;
    max-width: 100%;
    * {
      line-height: 0.36rem;
      font-size: 0.24rem !important;
    }
  }
}
</style>
